// extracted by mini-css-extract-plugin
module.exports = {"root":"Paywall_root__3-sty","slideDown":"Paywall_slideDown__14Iph","slideUp":"Paywall_slideUp__3osim"};